import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AlertDialogButton } from './alert-dialog.interface';

import { IonIcon } from '@ionic/angular/standalone';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- v22 migration pinned pre-existing zone-CD behavior; OnPush adoption is a separate effort
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonIcon],
})
export class AlertDialogComponent {
  @Input() title: string = '';
  @Input() message: string = '';

  @Input() buttons: AlertDialogButton[] = [];

  @Input() enableBackdropDismiss = true;

  @Input() hideFn: () => void = () => {};

  constructor() {}

  callHandler(handler?: () => void) {
    if (handler) {
      handler();
    }
    this.dismiss();
  }

  backdropDismiss() {
    if (this.enableBackdropDismiss) {
      this.dismiss();
    }
  }

  dismiss() {
    this.hideFn();
  }
}
